import engLabels from './eng'
import hebLabels from './heb'

export const eng = engLabels
export const heb = hebLabels
